export default __webpack_public_path__ + "static/media/download-results.a989806c.png";